import React, { useCallback, useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import actions from "../../actions";
import { getUserChats,getParticularChatByReceiverAndUserId } from "../../apis";
import "./ChatHistory.css";
import { IoMdArrowRoundBack } from "react-icons/io";
import ChatHistoryTable from "./ChatHistoryTable";

const ChatHistory = ({ startLoadingRequest, stopLoadingRequest,userId,receiverId,date }) => {
  const { id } = useParams();
  const [chatMessages, setChatMessages] = useState([]); // Store chat messages
  const [isback,setIsBack] = useState(false);

  // Helper function to group messages by date (in ascending order) and filter out blank messages
  const groupMessagesByDate = (messages) => {
    const groupsMap = new Map();
    const today = new Date();
    const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const yesterdayDate = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());

    // Sort messages in ascending order (oldest first)
    const sortedMessages = [...messages].sort(
      (a, b) => new Date(a.creationTime) - new Date(b.creationTime)
    );

    sortedMessages.forEach((message) => {
      // Filter out messages with blank or whitespace-only text
      if (!message.message || message.message.trim() === "") {
        return;
      }
      const msgDate = new Date(message.creationTime);
      const msgDateOnly = new Date(msgDate.getFullYear(), msgDate.getMonth(), msgDate.getDate());
      let groupName = "";
      if (msgDateOnly.getTime() === todayDate.getTime()) {
        groupName = "Today";
      } else if (msgDateOnly.getTime() === yesterdayDate.getTime()) {
        groupName = "Yesterday";
      } else {
        groupName = msgDate.toLocaleDateString(undefined, {
          month: "long",
          day: "numeric",
          year: "numeric",
        });
      }
      if (!groupsMap.has(groupName)) {
        groupsMap.set(groupName, []);
      }
      groupsMap.get(groupName).push(message);
    });

    // Build an array of groups in order of appearance (oldest group first)
    const groups = [];
    const seen = new Set();
    sortedMessages.forEach((message) => {
      // Skip blank messages
      if (!message.message || message.message.trim() === "") {
        return;
      }
      const msgDate = new Date(message.creationTime);
      const msgDateOnly = new Date(msgDate.getFullYear(), msgDate.getMonth(), msgDate.getDate());
      let groupName = "";
      if (msgDateOnly.getTime() === todayDate.getTime()) {
        groupName = "Today";
      } else if (msgDateOnly.getTime() === yesterdayDate.getTime()) {
        groupName = "Yesterday";
      } else {
        groupName = msgDate.toLocaleDateString(undefined, {
          month: "long",
          day: "numeric",
          year: "numeric",
        });
      }
      if (!seen.has(groupName)) {
        groups.push({ groupName, messages: groupsMap.get(groupName) });
        seen.add(groupName);
      }
    });
    return groups;
  };

  // Fetch user chat data
  const fetchUserChats = useCallback(async () => {
    try {
      const apiResponse = await getParticularChatByReceiverAndUserId(userId,receiverId,date);
      if (apiResponse?.data?.data) {
        setChatMessages(apiResponse.data.data); // Set chat messages from response
      }
    } catch (error) {
      console.error("Error fetching chat messages", error);
    }
  }, [id]);

  useEffect(() => {
    stopLoadingRequest();
    fetchUserChats();
  }, [fetchUserChats, stopLoadingRequest]);

  const groupedMessages = groupMessagesByDate(chatMessages);
  if(isback){
    return <ChatHistoryTable/>;
  }

  return (
    <div className="chat-div">
      <div className="chat-container">
        <div className="navbarContainer">
          <IoMdArrowRoundBack onClick={()=>setIsBack(true)} className="z-10" style={{cursor:"pointer"}}/>
            {/* <div
                  className="group-header"
                  style={{
                    textAlign: "center",
                    backgroundColor: "black",
                    color: "white",
                    padding: "5px 10px",
                    margin: "10px auto",
                    borderRadius: "4px",
                    width: "fit-content",
                   
                  }}
                >
                  {group.groupName}
            </div> */}
        </div>
        <div className="chat-history">
          {groupedMessages.length > 0 ? (
            groupedMessages.map((group) => (
              <div className="message-group" key={group.groupName}>
                
                {group.messages.map((message) => (
                  <div
                    key={message._id}
                    className={`chat-message ${
                      message.senderId === id ? "sent" : "received"
                    }`}
                  >
                    <p className="messages">{message.message}</p>
                    {message.options.length > 0 && (
                      <div className="message-options">
                        {message.options.map((option, idx) => (
                          <button key={idx} className="option-button">
                            {option}
                          </button>
                        ))}
                      </div>
                    )}
                    {message.media.length > 0 && (
                      <div className="message-media">
                        {message.media.map((mediaUrl, idx) => (
                          <img key={idx} src={mediaUrl} alt="media" />
                        ))}
                      </div>
                    )}
                    <small className="timestamp">
                      {new Date(message.creationTime).toLocaleString()}
                    </small>
                  </div>
                ))}
              </div>
            ))
          ) : (
            <p>No chat history available</p>
          )}
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logoutRequest: actions.auth.logout,
      stopLoadingRequest: actions.loader.stopLoading,
      startLoadingRequest: actions.loader.startLoading,
      deactivateSidebarRequest: actions.sidebar.deactivateSidebar,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(ChatHistory);
